import { render, staticRenderFns } from "./RowBlockRefundFundsTestContractDgo.vue?vue&type=template&id=7d5ed396&"
import script from "./RowBlockRefundFundsTestContractDgo.vue?vue&type=script&lang=js&"
export * from "./RowBlockRefundFundsTestContractDgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports